import type { RecallReason } from '@/types/regulatory';

// Підписи для enum RecallReason сервера
export const MD_RECALL_REASON_LABEL_MAP: Record<RecallReason, string> = {
  PotentialSterilityCompromise: 'Можливе порушення стерильності',
  ManufacturingDefect: 'Виробничий дефект',
  LabelingError: 'Помилка маркування',
  PerformanceIssue: 'Порушення функціонування',
  SafetyAlert: 'Попередження щодо безпеки',
  RegulatoryNonCompliance: 'Регуляторна невідповідність',
  Other: 'Інше',
};
